import { render } from "./page.vue?vue&type=template&id=1660840c"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=1660840c&lang=css"

import exportComponent from "C:\\Users\\jjoulia\\Documents\\projets\\booster-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])